import React from 'react'
import { connect } from 'react-redux'
import authSelector from '../../selectors/authSelector'

import LogoutMenuItem from '../common/LogoutMenuItem'
import StudentMenuItems from '../student/StudentMenuItems'
import TeacherMenuItems from '../teacher/TeacherMenuItems'
import SchoolMenuItems from '../school/SchoolMenuItems'
import ManagerMenuItems from '../manager/ManagerMenuItems'
import SupervisorMenuItems from '../supervisor/SupervisorMenuItems'
import Notification from '../common/Notification'
import MenuItem from '../common/MenuItem'

const menuItems = {
  STUDENT: <StudentMenuItems />,
  TEACHER: <TeacherMenuItems />,
  SCHOOL: <SchoolMenuItems />,
  MANAGER: <ManagerMenuItems />,
  SUPERVISOR: <SupervisorMenuItems />,
}

const AllMenuItems = ({ children, isSideBarOpen }) => (
  <div id="menu-item-container">
    <div>
      <MenuItem
        label='صفحه اصلی'
        iconClass='fa fa-home'
        url='/'
        isExternal={true}
      />
    </div>

    {children}

    <Notification isSideBarOpen={isSideBarOpen} />

    <LogoutMenuItem />
  </div>
)

const MenuItemsContainer = ({ userType, isSideBarOpen }) => (
  <AllMenuItems isSideBarOpen={isSideBarOpen}>
    {menuItems[userType]}
  </AllMenuItems>
)

const mapStateToProps = state => ({
  ...authSelector(state),
  isSideBarOpen: state.sidebar.isOpen,
})

export default connect(mapStateToProps)(MenuItemsContainer)



// WEBPACK FOOTER //
// ./src/components/dashboard/MenuItemsContainer.js